/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useRef, useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import { useACSelectionBoxContext } from '../ACContext/ACSelectionBoxContext';
import { _getStudyGroupedData } from '../../../util/autocodeUtils';
import { useDispatch, useSelector } from '../../common/react-redux-hooks';
import AutocodeSelectionBoxItems from './AutocodeSelectionBoxItems';
import InfoBox from '../../common/EnhancedGridFeature/InfoBox';
import { InfoBoxSpacer } from '../../common/EnhancedGridFeature/InfoBox';
import ACGridMenuItems from '../AutocodeGrid/ACGridMenu/ACGridMenuItems';
import downArrow from '../../../images/Autocode/downArrow.svg';
import folderIcon from '../../../images/Autocode/folder_icon.svg';
import {
  getDefinitionTreeLoad,
  clearDefinitionTarget,
} from '../../../actions/definitionActions';
import GenericEditWithCancelSave from '../../common/GenericEditWithCancelSave';

let groupedData = {
  personal: [],
  shared: [],
  global: [],
};

export const AutocodeSaveDefnSelectionBox = ({
  showingInDevOnly,
  numTopLevelNodes,
  definitionTab,
  moduleStudy,
  defPartsToShow,
  tempOverridelabels,
  setdefinition,
  setGroupWithOn,
  cancelBulkJoinSetup,
  saveDefnActive,
  setCheckBlur,
}) => {
  const acSelContext = useACSelectionBoxContext();
  const dispatch = useDispatch();
  const infoBoxRef = useRef(null);
  const [selectedFolderName, setSelectedFolderName] = useState(
    'Select Definition Folder'
  );
  const [dropPanels, setDropPanels] = useState([]);
  const [productNo, setProductNo] = useState(moduleStudy.pn);
  const [folders, setFolders] = useState([]);
  const [addFolder, setAddFolder] = useState(false);
  const [inputText, setInputText] = useState({});
  const [editing, setEditing] = useState(false);
  const [folderAdded, setFolderAdded] = useState(false);
  const [infoBoxSticky, setinfoBoxSticky] = useState([]);

  const { definitionList, activeAccountId } = useSelector(state => ({
    definitionList: state.definition.definitionTree,
    activeAccountId: state.account.activeAccountId,
  }));

  if (definitionList && definitionList.data && definitionList.data.length > 0) {
    groupedData = _getStudyGroupedData(definitionList.data);
  }

  const setSelectedFolder = defId => {
    folders.forEach(item => {
      if (item.definitionId === defId) {
        setSelectedFolderName(item.folderName);
        item.selected = true;
      } else {
        item.selected = false;
      }
    });
    setFolders(folders);
    setDropPanels([]);
  };

  useEffect(() => {
    setFolders(cloneDeep(groupedData.personal));
    setDropPanels([]);
  }, [JSON.stringify(groupedData.personal)]);

  useEffect(() => {
    setGroupWithOn(false);
    cancelBulkJoinSetup();
    if (moduleStudy) {
      dispatch(clearDefinitionTarget());
      dispatch(
        getDefinitionTreeLoad(
          '',
          moduleStudy.ss === 'SIMMONS' ? 1 : 2,
          activeAccountId,
          moduleStudy.pn
        )
      );
    }
  }, []);

  useEffect(() => {
    if (productNo !== moduleStudy.pn) {
      dispatch(
        getDefinitionTreeLoad(
          moduleStudy.ss === 'SIMMONS' ? 1 : 2,
          activeAccountId,
          moduleStudy.pn
        )
      );
      setProductNo(moduleStudy.pn);
    }
  }, [moduleStudy]);

  useEffect(() => {
    if (editing || addFolder) {
      inputText.focus();
      inputText.select();
    }
  }, [inputText]);

  useEffect(() => {
    if (folderAdded === true && folders && folders.length > 0) {
      setSelectedFolder(folders[0].definitionId);
      setdefinition({
        definitionId: folders[0].definitionId,
        folderName: folders[0].folderName,
      });
      setFolderAdded(false);
    }
  }, [JSON.stringify(folders)]);

  const buildInfoBoxSticky = () => {
    if (infoBoxSticky.length === 0) {
      const ibs = [];
      ibs.push(
        <ACGridMenuItems
          element="button"
          label={`+ ${'Add New Folder'}`}
          infoBoxRef={infoBoxRef}
          onElemClick={() => setAddFolder(true)}
        />
      );
      setinfoBoxSticky(ibs);
    }
    return infoBoxSticky;
  };

  const buildInfoBox = () => {
    if (dropPanels.length === 0) {
      const ibp = [];
      if (folders.length > 0) {
        folders.map(item =>
          ibp.push(
            <ACGridMenuItems
              style={
                item.selected === true
                  ? { background: 'rgba(121, 148, 187, 0.1)' }
                  : { background: 'transparent' }
              }
              element="span"
              label={item.folderName}
              infoBoxRef={infoBoxRef}
              onElemClick={() => {
                infoBoxRef.current.targetRef.current.click();
                setdefinition({
                  definitionId: item.definitionId,
                  folderName: item.folderName,
                });
                setSelectedFolder(item.definitionId);
              }}
              imgSrc={folderIcon}
            />
          )
        );
        ibp.push(
          <InfoBoxSpacer Height="0.1em" boxClassName="toolPalette-spacer-row" />
        );
        setDropPanels(ibp);
      }
    }
    return dropPanels;
  };

  const addNewFolder = folderName => {
    const tempFolder = {
      definitionId: '',
      expressions: [],
      folderName,
      lastModified: '',
      new: 0,
      productId: 0,
      scope: 4,
      shared: 0,
      studySource: 1,
    };
    const newFolders = cloneDeep(folders);
    const tempFolderIndex = newFolders.findIndex(
      folder => folder.definitionId === ''
    );
    if (tempFolderIndex !== -1) {
      newFolders.splice(tempFolderIndex, 1);
    }
    newFolders.unshift(tempFolder);
    setFolders(newFolders);
    setFolderAdded(true);
  };

  return (
    <div className="ac-selection-box-main-container">
      <div
        className="ac-selection-box-item-box"
        style={{ background: '#4E8FCB' }}
      >
        {!addFolder ? (
          <Fragment>
            <span className="select-folder-dd">
              <InfoBox
                ref={infoBoxRef}
                Panels={buildInfoBox()}
                updatePanels={buildInfoBox}
                Positions={['bottom']}
                Align="start"
                InfoBoxButtonInner={
                  <span>
                    <label className="select-folder-label">
                      {selectedFolderName}
                    </label>
                    <img
                      className="ibox-downArrow-label"
                      src={downArrow}
                      alt="v"
                    />
                  </span>
                }
                containerClassName="ib-popover-scrollable"
                stickyContent={buildInfoBoxSticky()}
                childClassName="ib-popover-child"
                setCheckBlur={setCheckBlur}
              />
            </span>
          </Fragment>
        ) : (
          <GenericEditWithCancelSave
            setEditing={setAddFolder}
            initValue=""
            saveInput={textValue => {
              setAddFolder(false);
              addNewFolder(textValue);
            }}
            setInputText={setInputText}
          />
        )}
      </div>
      {numTopLevelNodes() === 1 && (
        <div
          className={
            acSelContext.state.rootNode.children[0].useLabelOverride
              ? 'ac-selection-box-text-box-edited'
              : 'ac-selection-box-text-box'
          }
        >
          {editing ? (
            <GenericEditWithCancelSave
              setEditing={setEditing}
              initValue=""
              saveInput={textValue => {
                setEditing(false);
                tempOverridelabels(
                  acSelContext.state.rootNode.children[0].id,
                  textValue
                );
              }}
              setInputText={setInputText}
            />
          ) : (
            <span
              className={
                acSelContext.state.rootNode.children[0].useLabelOverride
                  ? 'ac-selection-box-text-box-edited-content'
                  : 'ac-selection-box-text-box-content'
              }
              onClick={() => setEditing(true)}
            >
              {acSelContext.state.rootNode.children[0].toLabelString(
                defPartsToShow,
                true
              )}
            </span>
          )}
        </div>
      )}
      <AutocodeSelectionBoxItems
        definitionTab={definitionTab}
        showingInDevOnly={showingInDevOnly}
        setGroupWithOn={setGroupWithOn}
        selectionboxData={acSelContext.state.rootNode.children.filter(
          item => item.selected
        )}
        saveDefnActive={saveDefnActive}
        selEditLabelBoxactive={numTopLevelNodes() === 1}
      />
    </div>
  );
};

AutocodeSaveDefnSelectionBox.propTypes = {
  showingInDevOnly: PropTypes.func,
  numTopLevelNodes: PropTypes.func,
  definitionTab: PropTypes.bool,
  moduleStudy: PropTypes.shape({
    ss: PropTypes.string,
    pn: PropTypes.number,
  }),
  groupedData: PropTypes.shape({
    personal: PropTypes.instanceOf(Array),
  }),
  defPartsToShow: PropTypes.shape({}),
  tempOverridelabels: PropTypes.func,
  setdefinition: PropTypes.func,
  setGroupWithOn: PropTypes.bool,
  cancelBulkJoinSetup: PropTypes.func,
  saveDefnActive: PropTypes.bool,
  setCheckBlur: PropTypes.bool,
};
